import React, { FC, HTMLAttributes } from 'react'
import { Box, BoxProps, Image, ImageProps } from '@chakra-ui/core'
import 'lazysizes'
import { DiscountBox } from '../DiscountBox'
import { QuantityBox } from '../QuantityBox'

export interface Props extends HTMLAttributes<BoxProps> {
  discount?: number
  quantity?: number
  imageUrl: string
  size?: string
  hideQuantity?: boolean
  hideDiscount?: boolean
  imageProps?: ImageProps
}

export const ImageBox: FC<Props> = ({
  hideDiscount,
  hideQuantity,
  quantity = 0,
  discount = 0,
  imageUrl,
  size,
  imageProps,
  ...props
}) => {
  return (
    <Box
      width="100%"
      pt="66.6%"
      position="relative"
      backgroundColor="white"
      {...props}
    >
      <Box
        borderRadius="4px"
        bgPos="center"
        d="flex"
        justifyContent="space-between"
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        padding={size === 'big' ? '4px' : '0'}
      >
        <Image
          data-src={imageUrl}
          h="100%"
          position="absolute"
          left="50%"
          transform="translateX(-50%)"
          className="lazyload"
          {...imageProps}
        />
        <Box position="relative">
          {!hideDiscount && <DiscountBox value={discount} size={size} />}
        </Box>
        <Box position="relative">
          {quantity > 0 && !hideQuantity && (
            <QuantityBox value={quantity} size={size} />
          )}
        </Box>
      </Box>
    </Box>
  )
}
